
import React, { useEffect } from 'react';
import './assets/css/App.css';

import { Toaster } from 'sileo';
import 'sileo/styles.css';
import { usePrefs } from './hooks/hooks.prefs';

import { useDispatch, useSelector } from 'react-redux';

import { removeAll } from './hooks/hooks.localStorage';
import { useLocation } from 'react-router-dom';


import BasicRouting from './routing/routing.basicRouting';
import SecurityRouting from './routing/routing.securityRouting';
import ViewHeader from './views/template/view.header';
import ViewFooter from './views/template/view.footer';

function App() {

  const user= useSelector((state)=> state.userReducer.user);
  const limit= useSelector((state)=>state?.userReducer?.limit);
  const dispatch= useDispatch();
  const location= useLocation();
  const { theme } = usePrefs();

  const logout= ()=>{
    dispatch({type: "logout"});
    removeAll();
  }

  useEffect(()=>{
    // session expirée après 1 mois
    const expiry= new Date(limit);
    expiry.setMonth(expiry.getMonth() + 1);
    if(limit && Date.now() >= expiry.getTime()){
      logout();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, location])


  return (
    <div className="App">
      {
        !user?.nom_complet ? 
        <div>
          <ViewHeader />
          <BasicRouting /> 
          <ViewFooter />
        </div>
        
        : <SecurityRouting />
      }
      <Toaster position="top-center" offset={{ top: 84 }} theme={theme} />
    </div>
  );
}

export default App;
